import { useSyncExternalStore } from "react";
import {
  getTextSendAttempts, prioritizeTextSendFailures,
  retryTextSendAttempt, subscribeTextSendAttempts,
} from "./textSendAttempts.mjs";
import { mergeTextSendMessages } from "./textSendMessages.mjs";

export function useTextSendAttempts() {
  return useSyncExternalStore(subscribeTextSendAttempts, getTextSendAttempts, getTextSendAttempts);
}
export function useTextSendPriority(items, target) {
  return prioritizeTextSendFailures(items, useTextSendAttempts(), target);
}
export function useTextSendMessages(messages, storeId, phone) {
  return mergeTextSendMessages(messages, useTextSendAttempts(), storeId, phone);
}
export function TextAttemptStatus({ attempt }) {
  if (!attempt) return null;
  const pending = ["waiting", "initial", "confirming"].includes(attempt.phase);
  return <span data-text-send-attempt={attempt.id} role={pending ? "status" : attempt.phase === "accepted" ? "status" : "alert"}>
    {pending ? (attempt.phase === "waiting" ? "Aguardando envio…" : "Enviando…")
      : attempt.phase === "accepted" ? "Na fila de envio"
      : <>
        <span>{attempt.uncertain ? "Envio não confirmado." : "Mensagem não enviada."} {attempt.error}</span>
        <button type="button" aria-label="Reenviar tentativa com segurança"
          onClick={() => retryTextSendAttempt(attempt.id)}
          style={{ marginLeft:5, cursor:"pointer" }}>Reenviar</button>
      </>}
    {attempt.storageError && <span> Não foi possível guardar esta tentativa na aba; verifique antes de recarregar.</span>}
  </span>;
}
export default function TextSendStatus() {
  // Legacy card callers must not repeat message state outside its bubble.
  return null;
}